export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8888/';

export const TOAST_SHOW_DURATION = 3000;
export const MENU_WIDTH = 240;

export const VALID_HOSPITALS = [
    `Тест`,
    `Boehringer`,
    `УМБАЛ "Проф. д-р Стоян Киркович" гр. Стара Загора`,
    `УМБАЛ "Св. Георги" гр. Пловдив`,
    `УМБАЛ "Св. Анна" гр. София`,
    `УМБАЛ "Медика" гр. Русе`,
    `МБАЛ "Хасково" гр. Хасково`,
    `Angiosur`,
    `Clínica del norte`,
    `Clinica las Americas`
]

export const COUNTRIES = [
    { name: 'Bulgaria', code: 'BG', lng: 'bg' },
    { name: 'Colombia', code: 'CO', lng: 'es' },
    { name: 'United States', code: 'US', lng: 'en' },
    { name: 'South Afirica', code: 'ZA', lng: 'en' }
];

export const USER_ROLES = {
    admin: 'ADMIN',
    doctor: 'DOCTOR'
}
